import { render, staticRenderFns } from "./CounselingChat.vue?vue&type=template&id=ce84749a&scoped=true"
import script from "./CounselingChat.vue?vue&type=script&lang=js"
export * from "./CounselingChat.vue?vue&type=script&lang=js"
import style0 from "./CounselingChat.vue?vue&type=style&index=0&id=ce84749a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce84749a",
  null
  
)

export default component.exports